import { mapGetters } from 'vuex';

export default {
    created() {
        this.$store.dispatch('setScrollTop', parseInt(this.$route.query.scrollTop || 0));
    },
    data() {
        const lastIndex = this.$route.query.index;
        return {
            activeIndexes: (lastIndex && JSON.parse(lastIndex)) || [0],
        }
    },
    methods: {
        onChange(e) {
            this.activeIndexes = e;
            for (var i = 0; i < this.collapseList.length; i++) {
                this.collapseList[i].active = e.indexOf(i) >= 0;
            }
        },
        //从内页返回时自动滚动到之前的位置
        autoScroll() {
            if (this.$x('.scroll_div').els.length) this.$x('.scroll_div')[0].scroll(0, this.scrollTop || this.$route.query.scrollTop || 0);
            this.resetQuery()
        },
        //重置当前页参数
        resetQuery() {
            this.$router.push({ query: {} })
        },
        getOffsetTop() {
            return this.$x('.scroll_div')[0].scrollTop;
        },
        //监控滚动距离
        monitorScroll() {
            this.$store.dispatch('setScrollTop', this.getOffsetTop())
        }
    },
    watch: {
        scrollTop(n, o) {}
    },
    computed: mapGetters(['scrollTop']),
}
